export const buildProtectedRouteRedirect = (targetPath: string): string => {
  const safeTarget = targetPath && targetPath.startsWith("/") ? targetPath : "/visits";
  return `/login?redirect=${encodeURIComponent(safeTarget)}`;
};

export const getRedirectTarget = (
  state?: { redirect?: string } | null,
  search?: string,
  fallback = "/visits"
): string => {
  const fromState = state?.redirect;
  if (fromState && fromState.startsWith("/")) {
    return fromState;
  }

  if (typeof search === "string" && search.trim()) {
    const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
    const redirect = params.get("redirect");
    if (redirect && redirect.startsWith("/")) {
      return redirect;
    }
  }

  return fallback;
};

export const isHostOrAdminUser = (user: any): boolean => {
  if (!user) return false;
  const groups = Array.isArray(user.groups) ? user.groups : [];
  const isSuperAdmin = Boolean(user.is_superuser);
  const normalizedGroups = groups.map((group: string) => String(group).trim().toLowerCase());

  const isHostRole = [
    "host",
    "host commercial",
    "host billing",
    "super host",
  ].some((role) => normalizedGroups.includes(role));

  const isAdminRole = isSuperAdmin || normalizedGroups.includes("admin");

  return isHostRole || isAdminRole;
};
